import isScrolling from './is-scrolling';
import mappedHTML from './mapped-html';
import scrollPosition from './scroll-position';
import selectedElement from './selected-element';
import selection from './selection';
import hoveredElement from './hovered-element';
import focusedElement from './focused-element';
import isLoaded from './is-loaded';
import isDisabled from './is-disabled';
import updatedAt from './updated-at';
import deviceMode from './device-mode';

export default {
  isScrolling,
  mappedHTML,
  scrollPosition,
  selectedElement,
  selection,
  hoveredElement,
  focusedElement,
  isLoaded,
  isDisabled,
  updatedAt,
  deviceMode,
};
